export const removeLeadingZeros = (number: string) => {
  const numberWithoutZeros = number.replace(/^0+/, '');
  if (numberWithoutZeros[0] === '.') {
    return '0' + numberWithoutZeros;
  }
  return numberWithoutZeros;
};
